import script from "./FindUserSearchBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FindUserSearchBox.vue?vue&type=script&setup=true&lang=js"

import "./FindUserSearchBox.vue?vue&type=style&index=0&id=2e5e1c0d&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebase 8x8\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5e1c0d"]])

export default __exports__